import { UserRolesIdsEnum } from '@verantos-dev/core-enums';
import type { IconType } from '@verantos-dev/shared-components';

export enum CurationPlatformAppId {
  annotationTool = 'annotationTool',
  accuracyDashboard = 'accuracyDashboard',
}

export interface CurationPlatformApp {
  id: CurationPlatformAppId;
  messageId: string;
  icon: IconType;
  requiredRoles: UserRolesIdsEnum[];
}

/**
 * Row order for the Curation Platform product switcher. This is the only
 * place that order lives — both apps derive their switcher rows from it.
 */
export const CURATION_PLATFORM_APPS: CurationPlatformApp[] = [
  {
    id: CurationPlatformAppId.annotationTool,
    messageId: 'curationPlatformNav.annotationTool',
    icon: 'sidebarDataAdmin',
    requiredRoles: [UserRolesIdsEnum.ANNOTATION_USER, UserRolesIdsEnum.ANNOTATION_MANAGER],
  },
  {
    id: CurationPlatformAppId.accuracyDashboard,
    messageId: 'curationPlatformNav.accuracyDashboard',
    icon: 'sidebarAccuracy',
    requiredRoles: [UserRolesIdsEnum.ACCURACY_VIEWER],
  },
];

/**
 * The Curation Platform apps the given roles grant access to, in
 * CURATION_PLATFORM_APPS order. An app is included when the user holds any
 * one of its requiredRoles.
 */
export const getEntitledCurationPlatformApps = (
  roleIds: UserRolesIdsEnum[]
): CurationPlatformApp[] =>
  CURATION_PLATFORM_APPS.filter((app) =>
    app.requiredRoles.some((requiredRole) => roleIds.includes(requiredRole))
  );
